export default __webpack_public_path__ + "static/media/8-BjarneNielsenHolstebro.e5551f99.png";